import type { HarvestCreatePayload, HarvestPayload, HarvestUpdatePayload } from "@/types";
import Harvest from "../models/harvest";
import Repository from "./repository";

const resource = "harvests";

// Recorded pickings (GET/POST/PATCH/DELETE /harvests/). Scoped to the current farm
// server-side. Default ordering: most recent first (-date, then -created_at).
export default {
  // List harvests, optionally restricted to a crop and/or a [start, end] date window.
  async getAll(params?: { crop?: number; start_date?: string; end_date?: string }): Promise<Harvest[]> {
    const { data } = await Repository.get(`/${resource}/`, { params });
    return data.map((harvest: HarvestPayload) => new Harvest(harvest));
  },
  async get(harvestId: number): Promise<Harvest> {
    const { data } = await Repository.get(`/${resource}/${harvestId}/`);
    return new Harvest(data);
  },
  async create(harvest: HarvestCreatePayload): Promise<Harvest> {
    const { data } = await Repository.post(`/${resource}/`, harvest);
    return new Harvest(data);
  },
  async update(harvestId: number, harvest: HarvestUpdatePayload): Promise<Harvest> {
    const { data } = await Repository.patch(`/${resource}/${harvestId}/`, harvest);
    return new Harvest(data);
  },
  delete(harvestId: number) {
    return Repository.delete(`/${resource}/${harvestId}/`);
  },
};
